<template>
    <div class="content-wapper">
        <div class="breadcrumb-div">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/main/zscqzhfw/zyrzfw' }">质押融资服务</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/main/zscqzhfw/zyrzfwBszn' }">办事指南</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
    export default {
        name: "zyrzfwBszn"
    }
</script>

<style scoped>
    .content-wapper{
        padding: 10px;
    }
    .breadcrumb-div{
        margin-top: 10px;
    }
</style>